<template>
  <div v-click-outside="outsideClosePopup" class="dropdown">
    <button
      id="dropdownMenuButtonRounded"
      class="btn btn-dropdown-actions dropdown-toggle float-right pt-1 custom-dropdown-block dropdown-rounded-button"
      :style="{ background: backgroundColor }"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      @click="closePopup"
    >
      <span class="dropdown-rounded-title">
        {{ selectedValue == null ? placeholder : selectedValue.name }}
      </span>
      <div class="rounded-chevron" :style="{ background: backgroundIconColor }">
        <em
          :class="{
            'fas fa-chevron-down': !expanded,
            'fas fa-chevron-up': expanded,
          }"
          :style="{ color: iconColor }"
        />
      </div>
    </button>
    <div
      class="dropdown-menu dropdown-menu-right dropdown-rounded-container"
      aria-labelledby="dropdownMenuButtonRounded"
    >
      <div
        v-for="(item, index) in items"
        :key="index"
        class="dropdown-rounded-item"
        @click="onSelectItem(item)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import ClickOutside from 'vue-click-outside';
export default {
  name: 'CustomDropDownRounded',
  directives: {
    ClickOutside,
  },
  data() {
    return {
      expanded: false,
      selected: '',
      selectedValue: null,
    };
  },
  props: {
    placeholder: {
      type: String,
      default: () => '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    backgroundColor: {
      type: String,
      default: () => '#a9b7b0',
    },
    backgroundIconColor: {
      type: String,
      default: () => '#3f5b61',
    },
    iconColor: {
      type: String,
      default: () => '#fff',
    },
    defaultValue: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    if (this.defaultValue)
      this.selectedValue = this.items.find((a) => a.id == this.defaultValue);
  },
  methods: {
    closePopup() {
      this.expanded = !this.expanded;
    },
    //This methods avoid the element have issues with expanded
    outsideClosePopup() {
      if (this.expanded) this.closePopup();
    },
    onSelectItem(item) {
      this.selectedValue = item;
      // this.selected = item.name
      this.expanded = !this.expanded;
      this.$emit('on-select-item', item);
    },
  },
};
</script>

<style scoped>
.dropdown-rounded-button {
  padding-left: 20px;
  border-radius: 22px;
  border: none;
  height: 2.7rem;
  width: auto;
}
.dropdown-rounded-button::after {
  display: none;
}
.dropdown-rounded-title {
  color: #fff;
  font-size: 16px;
  margin-right: 20px;
}
.dropdown-rounded-container {
  margin-bottom: -10px;
}
.dropdown-rounded-item {
  cursor: pointer;
  margin: 10px 10px 10px 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e2e2;
}
.rounded-chevron {
  display: inline-block;
  width: 30px;
  height: 30px;
  background: #3f5b61;
  color: #fff;
  padding: 5px;
  border-radius: 50px;
  line-height: 1.4;
  margin-right: 1px;
}
.rounded-chevron i {
  margin-bottom: -10px;
}
</style>
